import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

export enum ArticleClickedTrigger {
    ImageClick = 'Image Click',
    TitleClick = 'Title Click',
}

export type TrackArticleClickedPayload = TrackingPayload & {
    articleId: string;
    position: number;
    trigger: ArticleClickedTrigger;
};

type TrackArticleClickedParams = Omit<TrackArticleClickedPayload, 'pageName' | 'url'>;

export const trackArticleClickedAnalytics = (payload: TrackArticleClickedPayload) => {
    track(TrackingEvents.Article.ArticleClicked, payload);
};

export const useTrackArticleClickedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return ({ articleId, position, trigger }: TrackArticleClickedParams) => {
        trackArticleClickedAnalytics({
            articleId,
            pageName: getAmplitudePageNameFromPath(pathname),
            position,
            trigger,
            url,
        });
    };
};
